/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { AbstractRestService, arrayOf, RestSettings, SlicedDataSource } from '@gh/core-data';
import { XeroIssueLogDto } from './xero-issue-log.dto';
import { XeroIssueLogMapper } from './xero-issue-log.mapper';

@Injectable()
export class XeroIssueLogRestService extends AbstractRestService {
  constructor(settings: RestSettings) {
    super(settings);
  }

  findAllAsDataSource(filter: any): SlicedDataSource<XeroIssueLogDto> {
    const req = {
      searchString: filter.searchString,
      startDate: filter.startDate,
      endDate: filter.endDate,
    };

    return this.createSlicedDataSourceGet(`${this.bp}/xero-issue-logs`, req, undefined, arrayOf(XeroIssueLogMapper));
  }
}
